module.exports = __webpack_public_path__ + "img/9.793a5c92.jpg";